import { Operation } from 'rfc6902/diff'
import {
  ContentItem,
  GerberaArticle,
  GerberaComponent,
  GerberaContainer,
  GerberaHeader,
  isGerberaContainer
} from '../../../api/gerbera/contents'
import { OembedLink } from '../../../components/dialog/UrlEditorInterface'
import { ScriptContent } from '../../../misc/find-scripts'
import { INITIAL_COLOR } from '../../../components/constants/ColorPicker'

export { GerberaArticle, GerberaHeader, GerberaComponent, GerberaContainer, isGerberaContainer }

export interface GerberaContent extends ContentItem {
}

export { ScriptContent }

export default interface ComponentState {
  data: ComponentStore
  gerbera: GerberaContent
  isContentSaved: boolean
  timeStampForSaveState: number
  history: HistoryStore
}

export interface HistoryStore {
  currentIndex: number
  patches: Patch[]
}

export interface Patch {
  undoPatch: Operation[]
  redoPatch: Operation[]
}

export interface IComponentData {
  /** コンポーネントの種類 */
  readonly type: string,
  /** コンポーネントの識別子 */
  readonly id: string,
  /** 親コンポーネントの識別子 */
  parentId?: string,

  /* コンポーネント固有の値 */
  [key: string]: any
}

export interface IContainerData extends IComponentData {
  childIds: string[]
}

export interface ComponentStore {
  /** IDでコンポーネントを取得する */
  [id: string]: IComponentData
}

export const ARTICLE_ID = 'c__ARTICLE'

export { NORTH, SOUTH, EAST, WEST, Direction } from '../core/state'

export function isContainer(component: IComponentData): component is IContainerData {
  return (<IContainerData>component).childIds !== undefined
}

export function isSection(component: IComponentData): component is SectionData {
  return isContainer(component) && component.type === 'section'
}

export function isColumns(component: IComponentData): component is ColumnsData {
  return component.type === 'columns'
}

export function isImage(component: IComponentData): component is ImageData {
  return component.type === 'image'
}

export function isText(component: IComponentData): component is TextData {
  return component.type === 'text'
}

export function isUrl(component: IComponentData): component is UrlData {
  return component.type === 'url'
}

export class TextData implements IComponentData {
  readonly type = 'text'
  parentId?: string = undefined

  constructor(public readonly id: string, public text: string) {
  }
}

export class EmbedData implements IComponentData {
  readonly type = 'embed'
  parentId?: string = undefined

  constructor(public readonly id: string, public content: string) {
  }
}

export class UrlData implements IComponentData {
  readonly type = 'url'
  parentId?: string = undefined

  constructor(public readonly id: string, public oembedLink: OembedLink) {
  }
}

export class ImageData implements IComponentData {
  readonly type = 'image'
  parentId?: string = undefined
  linkUrl?: string = undefined
  width?: number = undefined
  height?: number = undefined
  /* 画像の data: 形式のURL。サーバ側のJSONに保存されない */
  _dataUrl?: string = undefined

  constructor(public readonly id: string, public fileName: string) {
  }
}

abstract class AbstractContainerData implements IContainerData {
  abstract readonly type: string
  parentId?: string = undefined
  childIds: string[] = []

  constructor(public readonly id: string) {
  }
}

export class RowsData extends AbstractContainerData {
  readonly type = 'rows'

  constructor(id: string) {
    super(id)
  }
}

export class ColumnsData extends AbstractContainerData {
  static readonly MAX_COLUMN_SIZE = 12
  readonly type = 'columns'
  itemSizes: number[] = []

  constructor(id: string) {
    super(id)
  }
}

interface ISectionBackground {
  color?: string
  image?: string
}

export class SectionData extends AbstractContainerData {
  readonly type = 'section'
  background: ISectionBackground = {
    color: INITIAL_COLOR,
    image: undefined
  }
  color?: string = INITIAL_COLOR
  image?: string = undefined

  constructor(id: string) {
    super(id)
  }
}
